export const ACTIVE = "active";
export const COMPLETED = "completed";
export const ALL_KEY = "all";
export const COMPLETED_KEY = "completed";
export const ACTIVE_KEY = "active";

export const TODO_LIST_EMPLOYEE_FILTER_KEY = "todo_list_employee_filter";
export const TODO_LIST_DATE_FILTER_KEY = "todo_list_date_filter";

export const DATE_FILTER_TYPE_PRESET = "PRESET";
export const DATE_FILTER_TYPE_CUSTOM_RANGE = "CUSTOM_RANGE";
